import publicApi from "./publicApi";
import handleApiError from "./errorHandler";

export const publicHttpService = {
  get: async <T>(url: string, params?: object): Promise<T> => {
    try {
      const response = await publicApi.get<T>(url, { params });
      return response.data;
    } catch (error) {
      // console.error(`GET ${url} failed`, error);
      throw handleApiError(error);
    }
  },

  post: async <T>(url: string, data?: object): Promise<T> => {
    try {
      const response = await publicApi.post<T>(url, data);
      return response.data;
    } catch (error) {
      // console.error(`POST ${url} failed`, error);
      throw handleApiError(error);
    }
  },

  put: async <T>(url: string, data?: object): Promise<T> => {
    try {
      const response = await publicApi.put<T>(url, data);
      return response.data;
    } catch (error) {
      // console.error(`PUT ${url} failed`, error);
      throw handleApiError(error);
    }
  },
};
